import { AppStatusFilterMeta } from '@src/main/modules/app_status/ui/filters/mapAppStatusFiltersToCriteria';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useMemo } from 'react';

export const useAppStatusFilters = () =>
  useMemo<AppStatusFilterMeta>(
    () => ({
      code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.BETWEEN }],
      },
      errorDescription: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      possibleSolution: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      public: { value: null, matchMode: FilterMatchMode.EQUALS },
      visibleApp: { value: null, matchMode: FilterMatchMode.EQUALS },
      severity: { value: null, matchMode: FilterMatchMode.EQUALS },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
      summary: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      title: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      version: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
    }),
    [],
  );
